/* Code 4 — availability caveat popup + the product-level line's visibility.
   Served from layout/theme.liquid because the popup is appended to <body> and
   has to work on cards, the product page and inside the quick-add drawer.
   EDIT THIS FILE DIRECTLY. code/avail_note_and_product_line.py first generated
   it but is a spent one-time migration: it refuses the live theme and exits at
   "Already applied (info button present)". Verified 2026-09-02. */
(function () {
  var sheet = null;

  function ensureSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'c4-note';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-live', 'polite');
    sheet.hidden = true;
    sheet.innerHTML =
      '<p class="c4-note__text"></p>' +
      '<button type="button" class="c4-note__close" aria-label="Close">×</button>';
    document.body.appendChild(sheet);
    sheet.querySelector('.c4-note__close').addEventListener('click', hideNote);
    return sheet;
  }

  function showNote(text) {
    var s = ensureSheet();
    s.querySelector('.c4-note__text').textContent = text;
    s.hidden = false;
  }

  function hideNote() { if (sheet) sheet.hidden = true; }

  // Capture phase, and stop propagation: a card's availability line sits INSIDE
  // the card link, so without this the note would open and the browser would
  // navigate to the product at the same time.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var info = t.closest('.c4-avail__info');
    if (info) {
      e.preventDefault();
      e.stopPropagation();
      showNote(info.getAttribute('data-c4-avail-note') || '');
      return;
    }
    if (sheet && !sheet.hidden && !t.closest('.c4-note')) hideNote();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) hideNote();
  });

  // The product-level line speaks only while the shopper has not finished
  // choosing. Once the selection resolves, the per-variant ship badge takes
  // over and this is hidden, so the page never carries two answers at once.
  // Single-variant products have no choice to make, so the badge owns it from
  // the start and the line stays hidden.
  function syncProductLine() {
    var lines = document.querySelectorAll('.c4-avail[data-c4-context="product"]');
    if (!lines.length) return;
    var scope = document.querySelector('product-form-component') || document;
    var btn = scope.querySelector('button[name="add"]');
    var label = btn ? (btn.textContent || '').trim().toLowerCase() : '';
    var incomplete = label.indexOf('select options') !== -1;
    var hasPicker = !!document.querySelector('variant-picker');
    for (var i = 0; i < lines.length; i++) {
      lines[i].hidden = hasPicker ? !incomplete : true;
    }
  }

  /* Code 4 2026-09-02 (task BA) — live ship timing on the product-level line.
     "In Stock — Ships Fast" said nothing about WHEN. This turns it into
     "In Stock — Ships Today (2h 15m left)", falling back to Ships Tomorrow or
     the next genuinely open day.

     The calculation is NOT duplicated here: it comes from window.C4Ship, which
     same-day-ship-badge.liquid exposes, so the line and the per-variant badge
     can never drift apart on the cutoff or the holiday calendar. Config is read
     off the badge element even while the badge is hidden.

     PRODUCT PAGE ONLY, by the [data-c4-context="product"] selector. Collection
     cards keep their server-rendered text: that snippet is deliberately JS-free
     because a grid renders dozens of them.

     ACCEPTED, Gregory's call 2026-09-02: before options are chosen this reads as
     a promise about the whole product, which is not strictly true -- on the Tek3
     pant, Black ships today in NO size. The info caveat carries that. If it ever
     draws complaints the fix is the wording ("Some options ship today"), not the
     logic. */
  function syncShipTiming() {
    if (!window.C4Ship || !window.C4Ship.shipInfo) return;
    var lines = document.querySelectorAll('.c4-avail--stock[data-c4-context="product"]');
    if (!lines.length) return;
    var badge = document.querySelector('.same-day-ship-badge');
    var cutoff = 12, tz = 'America/New_York';
    if (badge) {
      cutoff = parseInt(badge.getAttribute('data-cutoff-hour') || '12', 10);
      tz = badge.getAttribute('data-cutoff-tz') || tz;
    }
    var info;
    try { info = window.C4Ship.shipInfo(cutoff, tz); } catch (e) { return; }
    // Code 4 2026-09-14: every word capitalised, so the holiday label reads
    // "Ships Next Open Business Day" like "Ships Today" beside it.
    var label = info.label.replace(/(^|\s)\S/g, function (c) { return c.toUpperCase(); });
    var text = info.shipsToday
      ? 'In Stock \u2014 Ships Today (' + info.countdown + ' left)'
      : 'In Stock \u2014 Ships ' + label;
    for (var i = 0; i < lines.length; i++) {
      var el = lines[i].querySelector('.c4-avail__label');
      if (el && el.textContent !== text) el.textContent = text;
    }
  }

  function tick() { syncProductLine(); syncShipTiming(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  } else {
    tick();
  }
  document.addEventListener('shopify:section:load', tick);
  setInterval(tick, 400);
})();
